export enum ArticleTheme {
  MARKET_WRAP_UP = 'market-wrap-up',
  DISCOVER = 'discover',
}
